import React from 'react';
import './HorizontalCategoryTabs.css';

export interface HorizontalCategoryTabsProps {
  /**
   * Список категорий для отображения
   */
  categories: string[];
  /**
   * Выбранная категория. null означает, что выбрана опция "Все"
   */
  value: string | null;
  /**
   * Обработчик изменения выбранной категории
   */
  onChange: (category: string | null) => void;
  /**
   * Показывать ли опцию "Все категории"
   * @default true
   */
  showAllOption?: boolean;
  /**
   * Текст для опции "Все категории"
   * @default "Все категории"
   */
  allOptionLabel?: string;
  /**
   * Дополнительный CSS класс
   */
  className?: string;
  /**
   * Размер вкладок
   * @default "medium"
   */
  size?: 'small' | 'medium' | 'large';
  /**
   * Дополнительные стили
   */
  style?: React.CSSProperties;
}

const HorizontalCategoryTabs: React.FC<HorizontalCategoryTabsProps> = ({
  categories,
  value,
  onChange,
  showAllOption = true,
  allOptionLabel = 'Все категории',
  className = '',
  size = 'medium',
  style
}) => {
  const handleCategoryClick = (category: string | null) => {
    onChange(category);
  };

  return (
    <div className={`horizontal-category-tabs ${size} ${className}`} style={style}>
      {showAllOption && (
        <button
          type="button"
          className={`category-tab ${value === null ? 'active' : ''}`}
          onClick={() => handleCategoryClick(null)}
        >
          {allOptionLabel}
        </button>
      )}
      {categories.map((category) => (
        <button
          key={category}
          type="button"
          className={`category-tab ${value === category ? 'active' : ''}`}
          onClick={() => handleCategoryClick(category)}
        >
          {category}
        </button>
      ))}
    </div>
  );
};

export default HorizontalCategoryTabs;
